import { Selector, SizeVariant } from '@outdoorsyco/bonfire';
import { useIntl } from 'react-intl';

import { currencyOptions, useSessionCurrency } from '@/hooks/useSessionCurrency';

type TCurrencySelectorProps = {
  onSelect?: () => void;
};

export const CurrencySelector = ({ onSelect }: TCurrencySelectorProps) => {
  const intl = useIntl();

  const [activeCurrency, updateCurrency] = useSessionCurrency();

  // We intentionally use standalone Selector instead of SelectorGroup + RadioSelector.
  // SelectorGroup uses a radio group pattern where arrow key navigation immediately triggers
  // onChange, which would close this modal on every keystroke. Selector (checkbox-based)
  // only commits on Space/click, so keyboard users can Tab through options freely.
  return (
    <div
      role="group"
      aria-label={intl.formatMessage({
        id: 'hZsDV2',
        defaultMessage: 'Select currency',
        description: 'GlobalHeader > CurrencySelector > aria-label',
      })}
      className="grid grid-cols-2 gap-2 md:grid-cols-3">
      {[...currencyOptions]
        .sort(a => (a.value === activeCurrency ? -1 : 0))
        .map(option => (
          <Selector
            key={option.value}
            name="currency"
            value={option.value}
            ariaLabel={option.label}
            label={option.label}
            size={SizeVariant.Medium}
            isSelected={option.value === activeCurrency}
            onChange={isSelected => {
              // Selector is a toggle (checkbox) under the hood — guard against the
              // deselect case that fires when clicking the already-selected option.
              if (!isSelected) return;
              updateCurrency(option.value);
              onSelect?.();
            }}
          />
        ))}
    </div>
  );
};
